import type { Context, Plugin } from '@segment/analytics-next';
import type { Context as NodeContext, Plugin as NodePlugin } from '@segment/analytics-node';
import { geolocation } from '$lib/state/geolocation.svelte';
import { device } from '$lib/state/device.svelte';

export function createCommonContextPlugin<PluginType extends Plugin | NodePlugin>(): PluginType {
	const updateCommonContext = (ctx: PluginType extends Plugin ? Context : NodeContext) => {
		ctx.updateEvent('properties.geolocation', geolocation.data); // we might want to add this to the context in the future

		if (ctx.event.event !== 'Quiz Submitted') {
			ctx.updateEvent('properties.deviceData', device.data);
		}

		return ctx;
	};

	return {
		name: 'Add Common Context',
		type: 'enrichment',
		version: '1.0.0',
		isLoaded: () => true,
		load: () => Promise.resolve(),
		track: updateCommonContext,
		page: updateCommonContext,
		identify: updateCommonContext
	} as unknown as PluginType;
}
